import Parallax from 'parallax-js';
import gsap from 'gsap';

const heroSection = document.querySelector(".hero");
const paralaxContainer = document.querySelectorAll(".parallax");

if (heroSection && paralaxContainer.length && innerWidth > 1024) {

    paralaxContainer.forEach((elem) => {
        let parallaxInstance = new Parallax(elem);
        parallaxInstance.enable();
    });

    const heroDecorWrapper = document.querySelector('.hero__title-box');
    const heroDecor = document.querySelector('.hero__decor div');

    function updateCoordinates() {
        let rect = heroDecor.getBoundingClientRect();
        let containerRect = heroDecorWrapper.getBoundingClientRect();

        let topPos = `${Math.round(rect.top - containerRect.top)}px`;
        let leftPos = `${Math.round(rect.left - containerRect.left)}px`;

        document.documentElement.style.setProperty('--topPos', topPos);
        document.documentElement.style.setProperty('--leftPos', leftPos);

        requestAnimationFrame(updateCoordinates);
    }


    requestAnimationFrame(updateCoordinates);
}

const heroMediaParallax = document.querySelector('.js-hero-media-parallax');

if (heroSection && heroMediaParallax && innerWidth > 1024) {
    heroSection.addEventListener('mousemove', (event) => {
        const rect = heroSection.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;

        gsap.to(heroMediaParallax, {
            x: x * 42,
            y: y * 34,
            duration: 0.8,
            ease: 'power2.out',
        });
    });

    heroSection.addEventListener('mouseleave', () => {
        gsap.to(heroMediaParallax, {
            x: 0,
            y: 0,
            duration: 0.8,
            ease: 'power2.out',
        });
    });
}
